// extracted by mini-css-extract-plugin
export var picture = "styles-module--picture--f1650";
export var pictureBackground = "styles-module--pictureBackground--06ac9";
export var pictureComment = "styles-module--pictureComment--6949e";
export var pictureWrapper = "styles-module--pictureWrapper--92d07";